"use client"

import { useState, useEffect } from "react"
import Navbar from "./components/Navbar"
import Hero from "./components/Hero"
import About from "./components/About"
import Products from "./components/Products"
// import Industries from "./components/Industries"
import WhyChooseUs from "./components/WhyChooseUs"
import Contact from "./components/Contact"
// import Gallery from "./components/Gallery"
import Faq from "./components/Faq"
import Blog from "./components/Blog"
import Footer from "./components/Footer"
import Popup from "./components/Popup"
import "./App.css"

function App() {
  const [activeSection, setActiveSection] = useState("home")
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <div className="app">
      <Navbar activeSection={activeSection} setActiveSection={setActiveSection} scrollY={scrollY} />
      <main>
        <section id="home">
          <Hero />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="products">
          <Products />
        </section>
        {/* <section id="industries">
          <Industries />
        </section> */}
        <section id="why-choose-us">
          <WhyChooseUs />
        </section>
        {/* <section id="gallery">
          <Gallery />
        </section> */}
        <section id="faq">
          <Faq />
        </section>
        <section id="blog">
          <Blog />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      <Footer />
      <Popup /> 
    </div>
  )
}

export default App
